import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Customer/Header";
import VehicleGrid from "../../components/Customer/VehicleGrid";
import BookingModal from "../../components/Customer/BookingModal";
import ExplorePlaces from "../../components/Customer/ExplorePlaces";
import AirportTransfer from "../../components/Customer/AirportTransfer";
import Footer from "../../components/Customer/Footer";
import { VEHICLES } from "../../constants/vehicles";

function CustomerBookingPage() {
  const navigate = useNavigate();
  const vehicles = VEHICLES;
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [message, setMessage] = useState("");

  const handleDestinationSelect = (destinationName) => {
    navigate(`/day-trips?destination=${encodeURIComponent(destinationName)}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-amber-100 font-sans">
      <Header />
      <main className="max-w-7xl mx-auto px-6 py-10 space-y-16">
        {/* Airport Transfers - First */}
        <AirportTransfer />
        
        {/* Explore Places - Second */}
        <ExplorePlaces onSelect={handleDestinationSelect} />
        
        {/* Vehicles - Third */}
        <section className="rounded-3xl bg-white/70 backdrop-blur border border-white/40 shadow-xl ring-1 ring-black/5">
          <div className="px-6 py-8 sm:px-10 sm:py-12">
            <div className="mb-8 flex items-end justify-between gap-4">
              <div>
                <p className="text-sm uppercase tracking-widest text-blue-700/70 font-semibold">Explore</p>
                <h2 className="mt-1 text-3xl sm:text-4xl font-bold text-gray-900 font-poppins">Available Vehicles</h2>
                <p className="mt-2 text-gray-600">Choose the perfect ride for your next journey.</p>
              </div>
            </div>
            <VehicleGrid vehicles={vehicles} onBookNow={setSelectedVehicle} />
          </div>
        </section>

      </main>
      {selectedVehicle && (
        <BookingModal
          vehicle={selectedVehicle}
          onClose={() => setSelectedVehicle(null)}
          setMessage={setMessage}
          message={message}
        />
      )}
      <Footer />
    </div>
  );
}

export default CustomerBookingPage;
